















































































import { Component, Mixins } from 'vue-property-decorator';
import BodyMapMixins from '@/mixins/BodyMapMixins';
import TransitionMixins from '@/mixins/TransitionMixins';
import RiskProfileOptions from '@/components/RiskProfile/RiskProfileOptions.vue';
import { mapState, mapGetters } from 'vuex';

@Component({
  components: {
    RiskProfileOptions,
  },
  computed: {
    ...mapState('RiskProfile', {
      riskProfile: 'riskProfile',
      bodyParts: 'bodyParts', // is used in BodyMapMixins
    }),
    ...mapState('Business', {
      business: 'business',
    }),
    ...mapGetters('RiskProfile', {
      enabledQuestionGroups: 'enabledQuestionGroups',
      bodyPartPreviewItems: 'bodyPartPreviewItems',
    }),
  },
})
export default class RiskProfileRead extends Mixins(
  BodyMapMixins,
  TransitionMixins
) {
  // RiskProfile State
  riskProfile!: Model;

  // Business State
  business!: Model;

  // Getters
  enabledQuestionGroups!: [];
  bodyPartPreviewItems!: [];

  showHistory = false;
  questionGroupDescription =
    'Here is the list of the question groups the individual will complete which will provide the relevant information in their report.';

  // Computed
  get riskProfileVal() {
    return this.riskProfile;
  }
  set riskProfileVal(v) {
    this.$store.commit('RiskProfile/SET_RISK_PROFILE', v);
  }

  get eventLogs() {
    return this.riskProfile.event_logs?.filter(
      (log) => log.category === 'business' && log.user
    );
  }

  get sortedRiskProfileItem() {
    return this.riskProfileVal.items.sort((a, b) => {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    });
  }

  // BeforeMount
  beforeMount() {
    this.business.object_id = this.$route.params.businessOid;

    this.$store.dispatch(
      'RiskProfile/fetchFullStructure',
      this.$route.params.riskProfileOid
    );
  }

  toBooking() {
    this.$router.push({
      name: 'business-booking-create',
      query: {
        riskProfileOid: this.riskProfile.object_id || '',
      },
    });
  }
}
